// Accordion thông tin chi tiết — click .acc-head để mở/đóng (toggle độc lập từng item)
$(function () {
	$("#Frame7 .detail-acc .acc-head").on("click", function () {
		$(this).closest(".acc-item").toggleClass("is-active");
		// #Frame7 height auto -> đổi theo accordion. Bắn resize để lib mainsite tính lại
		// scale + chiều cao trang (nếu không, scroll/scale giữ theo chiều cao cũ).
		window.dispatchEvent(new Event("resize"));
	});
});

// Swiper KOLs — Swiper v8 (global từ libraryMainsite)
// INIT LAZY: chỉ tạo khi view "hashtag" mở lần đầu. Init lúc view ẩn (width=0) -> loop offset +
// slide width sai -> chỉ hiện 2 thẻ. Nav gọi window.initF7Swiper() khi mở view.
window.f7Swiper = null;
window.initF7Swiper = function () {
	if (window.f7Swiper) { window.f7Swiper.update(); return window.f7Swiper; }
	window.f7Swiper = new Swiper("#Frame7 .f7-swiper", {
		loop: true,
		slidesPerView: 3,
		centeredSlides: true,
		spaceBetween: 10, // mobile mặc định; PC override qua breakpoint
		breakpoints: { 769: { spaceBetween: 40 } },
		speed: 500,
		navigation: { nextEl: "#Frame7 .f7-swiper-next", prevEl: "#Frame7 .f7-swiper-prev" },
		pagination: { el: "#Frame7 .f7-swiper-pagination", clickable: true },
	});
	return window.f7Swiper;
};
